export { default } from './DeliveryDetails';
